import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, useLocation } from 'react-router-dom'
import './index.css'
import i18n, { applyHtmlLanguageAttributes } from './i18n.js'
import App from './App.jsx'
import { AuthProvider } from './auth/AuthProvider.jsx'
import { AlertProvider } from './components/ui/alerts.jsx'
import { initializeObservability } from './observability/faro.js'

initializeObservability()

function HtmlLanguageSync() {
  const location = useLocation()

  useEffect(() => {
    const sync = (lng) => {
      applyHtmlLanguageAttributes(lng || i18n.resolvedLanguage || i18n.language, location.pathname)
    }

    sync(i18n.resolvedLanguage || i18n.language)
    i18n.on('languageChanged', sync)

    return () => {
      i18n.off('languageChanged', sync)
    }
  }, [location.pathname])

  return null
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AuthProvider>
      <AlertProvider>
        <BrowserRouter>
          <HtmlLanguageSync />
          <App />
        </BrowserRouter>
      </AlertProvider>
    </AuthProvider>
  </StrictMode>,
)
